/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { View, Text, Image, StyleSheet } from 'react-native';
import images from '../../constants/images';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

export default function SplashScreen({ navigation }) {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  useEffect(() => {
    const timer = setTimeout(() => {
      navigation.replace('Home');
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <View style={styles.container}>
      <Image
        source={images.logoFull}
        style={styles.logo}
        resizeMode="contain"
      />
      <Text style={styles.text}> copy rights JobEng 2024</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
  },
  logo: { width: 220, height: 220, marginBottom: 180 },
  text: { fontSize: 12, fontWeight: 'bold', color: '#333' },
});
